export default {
  type: 'symbol',
  id: 'stops',
  minzoom: 13.8,
  layout: {
    'text-optional': true,
    'text-size': [
      'step',
      ['zoom'],
      ['step', ['get', 'sizerank'], 18, 5, 12],
      17,
      ['step', ['get', 'sizerank'], 18, 13, 12],
    ],
    'icon-image': 'stop',
    'text-ignore-placement': ['step', ['zoom'], true, 15, false],
    'text-font': ['Inter Medium', 'Arial Unicode MS Regular'],
    'text-offset': [
      'step',
      ['zoom'],
      [
        'step',
        ['get', 'sizerank'],
        ['literal', [0, 0]],
        5,
        ['literal', [0, 0.75]],
      ],
      17,
      [
        'step',
        ['get', 'sizerank'],
        ['literal', [0, 0]],
        13,
        ['literal', [0, 0.75]],
      ],
    ],
    'icon-size': [
      'interpolate',
      ['linear'],
      ['zoom'],
      13.8,
      0.6,
      15,
      1,
    ],
    'text-anchor': [
      'step',
      ['zoom'],
      ['step', ['get', 'sizerank'], 'center', 5, 'top'],
      17,
      ['step', ['get', 'sizerank'], 'center', 13, 'top'],
    ],
    'text-field': ['coalesce', ['get', 'name_de'], ['get', 'name']],
  },
  paint: {
    'text-halo-color': [
      'match',
      ['get', 'class'],
      'park_like',
      'hsl(133, 38%, 100%)',
      'education',
      'hsl(148, 5%, 100%)',
      'medical',
      'hsl(200, 5%, 100%)',
      'hsl(187, 5%, 100%)',
    ],
    'text-halo-width': 1,
    'text-halo-blur': 0.5,
    'text-translate': [0, 3],
    'text-color': 'hsl(0, 0%, 10%)',
    'text-opacity': [
      'interpolate',
      ['linear'],
      ['zoom'],
      15.5,
      0,
      15.501,
      1,
    ],
  },
};
